import { type KeyConcept } from '@editor2/types/pageElements';
import { type Chapter } from '@editor2/types/chapter';
import { type PageGroup } from '@editor2/types/pageGroup';
import { type Entity } from '@editor2/types/entity';

/**
 * Coerces an authored key concept (which may be a plain string or an object)
 * into the editable `{ concept, description }` shape used by the UI.
 */
export const normalizeConcept = (concept: KeyConcept | string): KeyConcept =>
	typeof concept === 'string'
		? { concept, description: '' }
		: { concept: concept.concept ?? '', description: concept.description ?? '' };

/**
 * Resolves the family id of the chapter that contains the given page, whether
 * the page is attached directly to the chapter or nested under a page group.
 * Returns undefined if no containing chapter can be found.
 */
export const findChapterFamilyId = (
	chapters: Entity<Chapter>,
	pageGroups: Entity<PageGroup>,
	pageId: string
): string | undefined => {
	const pageGroupId = Object.keys(pageGroups.entities).find((key) =>
		pageGroups.entities[key].pages?.includes(pageId)
	);

	return Object.keys(chapters.entities).find((key) => {
		const chapter = chapters.entities[key];
		return (
			chapter.pages?.includes(pageId) ||
			(pageGroupId != null && chapter.page_groups?.includes(pageGroupId))
		);
	});
};
